import { PosInitData } from 'tplus-poslogin';
import { runInAction, history, i18n } from 'mutants-microfx';
import { serverLog } from 'tplus-api';
import { DataModel } from 'mutants-appfx';
import { Message, ModalWraper } from 'tplus-components-touch';
import { action } from 'mobx';
import { DeliveryStatus, DataClient, DistributionMode, DataSource } from '../../commom/Enum';
import RetailApi from '../../api/RetailApi';
import '../../commom/Challenger';
const t = i18n.getFixedT(null, 'newretail');

/**
 * 初始化单据
 *
 * @export
 * @class InitDataProcessor
 * @auther 马坚
 */
export class InitDataProcessor {
    @action
    static async execute(dto) {
        $T.debugger();
        // // 演示期判断
        // let isDemoOverDue= PosInitData('IsDemoOverDue');
        // if (isDemoOverDue) {
        //     throw new BizError("该功能模块已超出演示期!");
        // }

        // if(new Date().getTime()%2 === 0){
        //     Message.warn('未获取XXX值,请执行XXX操作');
        //     setTimeout(()=>{
        //         history.replace('/');
        //     },3000);
        // }

        console.log("restore前的数据：" + JSON.stringify(dto));
        dto.restore();
        console.log("restore后的数据：" + JSON.stringify(dto));

        dto.POSCode = PosInitData('posCode');

        dto.Idstore = PosInitData('storeID') || null;//暂时默认置成null
        // 默认为当前系统的登录日期
        dto.VoucherDate = PosInitData('VoucherDate');

        // 多营销机构临时值
        dto.IdmarketingOrgan = PosInitData('IdmarketingOrgan');
        // 收银员名字
        dto.UserName = PosInitData('UserName');
        // 收银员编码
        dto.UserCode = PosInitData('UserCode');
        // 收银员ID
        dto.UserId = PosInitData('UserId');
        //临时添加的值
        //业务类型
        dto.IdbusiType = 34;
        //交班单ID
        dto.IdShiftVoucher = PosInitData('IdShiftVoucher');
        //交班单号
        dto.ShiftCode = PosInitData('ShiftCode');
        //班次值
        dto.Shift = { Id: PosInitData('Shift') };
        // 日结单id
        dto.IdDailyVoucher = PosInitData('IdDailyVoucher');
        // 日结单号
        dto.DailyCode = PosInitData('DailyCode');

        // 导购员
        // 默认=收银员关联员工档案的员工编码，若收银员没有关联员工档案，员工档案导购属性为否，则默认=空；
        let person = PosInitData('Person');
        if (person) {
            dto.Person = dto.createValue("Person", JSON.parse(person));
            dto.Idperson = dto.Person.ID;
        }
        // 部门
        dto.IDDepartment_Store = PosInitData('IDDepartment_Store');

        // 发货状态
        if (!dto.DeliveryStatus) {
            dto.DeliveryStatus = {};
        }

        dto.DeliveryStatus.Id = DeliveryStatus.Code_02;
        // 零售数据端来源
        if (!dto.DataClient) {
            dto.DataClient = {};
        }
        dto.DataClient.Id = DataClient.Code_02;
        // 配送方式
        if (!dto.DistributionMode) {
            dto.DistributionMode = {};
        }
        dto.DistributionMode.Id = DistributionMode.Code_01;
        if (!dto.DataSource) {
            dto.DataSource = {};
        }
        dto.DataSource.Id = DataSource.Code_02;
        this.handleGetInstance(dto);
    }

    static async handleGetInstance(dto) {
        //用户信息
        const userId = PosInitData('UserId');
        const userName = PosInitData('UserName');
        const userParams = JSON.stringify({ userId, userName });
        try {
            serverLog('newretail', { eventId: 'SettleSuccessProcess_InitDataProcessor_trigger_GetInstance', param: userParams });
            let retailDTO = await RetailApi.GetInstance(dto.cut());
            await runInAction(() => {
                const { Code = '', VoucherDate } = retailDTO || {};
                serverLog('newretail', { eventId: 'SettleSuccessProcess_InitDataProcessor_GetInstance_after', param: JSON.stringify({ userParams, Code, VoucherDate }) });
                if (!Code) {
                    ModalWraper.confirm({
                        title: t('温馨提示'),
                        okText: '重试',
                        cancelText: '取消',
                        content: t('初始化失败,请重试!'),
                        onOk: () => {
                            this.handleGetInstance(dto);
                        },
                        onCancel: () => {
                            history.push('/');
                        }
                    })
                } else {
                    dto.Code = retailDTO.Code;
                    dto.VoucherDate = new Date(retailDTO.VoucherDate);
                }
            })
        } catch (error) {
            serverLog('newretail', { eventId: 'SettleSuccessProcess_InitDataProcessor_GetInstance_error', param: userParams });
        }
    }
}
